<script setup lang="ts">
import ILxcActivity from "~icons/lxc/activity";

const { t } = useI18n();

const props = defineProps<{
  successPkiConnectivity: boolean | undefined;
  errorPkiConnectivity: boolean;
  isLoading?: boolean;
}>();

const stateClasses = computed(() => {
  const classes = [
    "rounded-2xl",
    "text-white",
    "text-xs",
    "font-medium",
    "px-2",
    "py-0.5",
    "flex",
    "items-center",
  ];
  if (props.successPkiConnectivity) {
    classes.push("bg-success-700");
  } else if (props.errorPkiConnectivity) {
    classes.push("bg-error-700");
  }
  return classes;
});

const containerClass = computed(() => {
  const classes = [
    "flex",
    "items-center",
    "gap-2",
    "rounded-2xl",
    "pl-1",
    "pr-2.5",
    "py-1",
    "whitespace-nowrap",
    "h-[30px]",
  ];
  if (!props.successPkiConnectivity && !props.errorPkiConnectivity) {
    classes.push("invisible");
  }
  if (props.successPkiConnectivity) {
    classes.push("!bg-success-50");
  } else if (props.errorPkiConnectivity) {
    classes.push("!bg-error-50");
  }

  return classes;
});
</script>

<template>
  <div :class="containerClass">
    <div :class="stateClasses">
      <span v-if="successPkiConnectivity">{{
        t("pki.testConnection.ok")
      }}</span>
      <span v-else>{{ t("pki.testConnection.ko") }}</span>
    </div>
    <i-lxc-activity v-if="!isLoading" class="h-4 w-4" />
  </div>
</template>
